import React from "react";

const Chapter1 = () => {
  return (
    <>
      <h2>Nutrients Storyline</h2>
      <img
        style={{ width: "88%", margin: "20px auto" }}
        alt="holding pond westerly creek"
        src="/static/img/storylines/holding-pond-westerly-creek.jpg"
      />

      <p>
        Don't know much about nutrients? The storyline is the perfect place to
        start. Learn what nutrients are, how they get into the South Platte
        River and its tributaries and what can be done to reduce their pollutant
        load.
      </p>
    </>
  );
};

export default Chapter1;
